<template>
	<div name="pc-renew-container">
		<navigation />
		<hero />
		<introduction />
		<feature />
		<proof />
		<healthcare />
		<soldoc-review />
		<contact />
		<page-footer />
		<!-- <main-popup /> -->

		<!-- <float-btn /> -->
		<!-- <PopupSlider /> -->
	</div>
</template>

<script>
import Navigation from "@/components/pc_main/Navigation";
import Hero from "@/components/pc_main/Hero";
import Introduction from "@/components/pc_main/Introduction";
import Feature from "@/components/pc_main/Feature";
import Proof from "@/components/pc_main/Proof";
import Healthcare from "@/components/pc_main/Healthcare";
import SoldocReview from "@/components/pc_main/SoldocReview";
import Contact from "@/components/pc_main/Contact";
import PageFooter from "@/components/pc_main/PageFooter";
// import MainPopup from "@/components/pc_main/MainPopup";
// import Commingsoon from '@/components/pc_main/Commingsoon';
// import FloatBtn from '@/components/pc_main/FloatBtn';
// import PopupSlider from '@/components/pc_main/PopupSlider';

export default {
	name: "pcRenewContainer",
	components: {
		Navigation,
		Hero,
		Introduction,
		Feature,
		Proof,
		Healthcare,
		SoldocReview,
		Contact,
		PageFooter,
		// MainPopup
		// Commingsoon,
		// FloatBtn,
		// PopupSlider
	}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/PcContainer.vue